import React, { Component, useState } from 'react'
import Modal from 'react-bootstrap/Modal';
 
const CongratulationsPopup = (props) => {
return (
  <Modal {...props} className="congrats-popup" aria-labelledby="contained-modal-title-vcenter" centered>
    <section className='congrats-modal'>
      <Modal.Body>
        <section className='content'>
          <h1>CONGRATULATIONS!</h1>
          {/* <p>You are now a CMX Rewards {props.state.updateMemberShipAPI != '' && props.state.updateMemberShipAPI.data.tier} Member.</p> */}
          <p>Your Rewards Number: 
            {props.state.otpAPI != '' && props.state.otpAPI.memberid}
            {props.state.updateMemberShipAPI != '' && props.state.updateMemberShipAPI.data.membershipId}
          </p>
          <aside className="cmx-flex-btn-group text-start pt-4">
            <a onClick={props.congratsOkBtn} className="flex-btn" href="javascript:;" title="OK"><span>OK</span></a>
          </aside>
        </section>
      </Modal.Body>
    </section>
  </Modal>
)}
export default CongratulationsPopup;